import { useEffect } from "react";

const KEYBOARD_ACTIVATION_KEYS = new Set(["Enter", " "]);

function prepareInteractiveElement(element) {
  if (!(element instanceof HTMLElement) || element.dataset.a11yEnhanced === "true") {
    return;
  }

  element.dataset.a11yEnhanced = "true";
  element.setAttribute("role", "button");
  element.setAttribute("tabindex", "0");

  const handleKeyDown = (event) => {
    if (!KEYBOARD_ACTIVATION_KEYS.has(event.key)) return;
    event.preventDefault();
    element.click();
  };

  element.addEventListener("keydown", handleKeyDown);
  element.__eethsaKeyHandler = handleKeyDown;
}

function enhanceDocument(root = document) {
  root.querySelectorAll?.(".collapsible-header").forEach(prepareInteractiveElement);

  const main =
    root.querySelector?.(".content-body, main, .vh-100") ||
    document.querySelector(".content-body, main, .vh-100");
  if (main) {
    main.id = "main-content";
    main.setAttribute("role", "main");
    main.setAttribute("tabindex", "-1");
  }
}

export default function AccessibilityEnhancer() {
  useEffect(() => {
    enhanceDocument();

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node instanceof HTMLElement) {
            if (node.matches(".collapsible-header")) prepareInteractiveElement(node);
            enhanceDocument(node);
          }
        });
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
    return () => {
      observer.disconnect();
      document.querySelectorAll("[data-a11y-enhanced='true']").forEach((element) => {
        if (element.__eethsaKeyHandler) {
          element.removeEventListener("keydown", element.__eethsaKeyHandler);
          delete element.__eethsaKeyHandler;
        }
      });
    };
  }, []);

  return (
    <a className="eethsa-skip-link" href="#main-content">
      Saltar al contenido principal
    </a>
  );
}
